import RequestError from './RequestError.js';

export default class ApiConflictError extends RequestError {
    constructor(method, url, xhr, message = `API conflict error: ${method} ${url} [${xhr.status}]`) {
        super(method, url, xhr, message);
        this.error = xhr.responseJSON.errors[0].error_message;
        this.extraData = xhr.responseJSON.extra_data;
    }
}
